
import { Component } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getOptionList } from "@/api/api-dict";
import { getDeviceOprPage, sendPileOperation } from "@/api/api-basic";

import qrcodeShow from "@/components/qrcode/qrcode.vue";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import piSelectStation from "@/components/select-station/select-station.vue";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import i18n from "@/config/i18n";
@Component({
  components: {
    qrcodeShow,
    piSelectOper,
    piSelectTableData,
    "pi-select-station": piSelectStation
  }
})
export default class PiPileSList extends mixins(tableMaxHeight) {
  private privilegeVoObj: objAny = {};
  private formInline: objAny = {
    oprPkId: "",
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private gunStatusColor: objAny = {
    "0": "orange",
    "1": "primary",
    "2": "error",
    "3": "default",
    "4": "default",
    "7": "primary",
    "8": "warning",
    "9": "purple"
  };
  private loading = false;
  private staStatusList: objAny[] = [];
  private total = 0;
  private win: objAny = Window;
  private isGoBack = false;
  private tableList: object[] = [];
  private tableColumns: object[] = [];
  private searchShow = true;
  private allTableData: object[] = [
    {
      title: i18n.t("pileList.staName"),
      key: "staName",
      minWidth: 180
    },
    {
      title: i18n.t("commonTableName.ratedPower"),
      key: "ratedPower",
      minWidth: 140
    },
    {
      title: i18n.t("commonTableName.serialNumber"),
      key: "serialNumber",
      minWidth: 140
    },
    {
      title: i18n.t("commonTableName.pileName"),
      key: "pileName",
      minWidth: 160,
      slot: "pileName"
    },
    {
      title: i18n.t("commonTableName.deviceType"),
      key: "deviceTypeDesc",
      minWidth: 130
    },
    {
      title: i18n.t("pileList.chargeGunInfoVoList"),
      key: "chargeGunInfoVoList",
      minWidth: 150,
      slot: "GunNo"
    },
    {
      title: i18n.t("pileList.gunStatus"),
      key: "chargeGunInfoVoList",
      minWidth: 100,
      slot: "gunStatus"
    },
    {
      title: i18n.t("pileList.deviceStatus"),
      key: "deviceStatusDesc",
      minWidth: 120,
      slot: "deviceStatusDesc"
    }
  ];

  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public searchClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }

  public formDataNull(data: objAny): objAny {
    const json: objAny = {};
    for (const i in data) {
      if (data[i] !== "" && data[i] !== undefined) {
        json[i] = data[i];
      }
    }
    return json;
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getDeviceOprPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }

  async showUnlock(row: objAny, item: objAny) {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("pileList.showUnlockConfirm") + "",
      onOk: async () => {
        const ret = await sendPileOperation({
          gunPkId: item.gunPkId,
          operationType: 2,
          serialNumber: row.serialNumber,
          pilePkId: row.pilePkId
        });
        if (ret.status === this.$config.apiStatus) {
          this.$Message.success(i18n.t("pileList.showUnlockSuccess"));

          this.getTableList();
        }
      }
    });
  }
  public bindDetail(item: objAny) {
    this["$common"].save("/pile-manage/pile-list/pile-detail", item); // 存在本地
    this["$router"].push("/pile-manage/pile-list/pile-detail");
  }

  mounted() {
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
    getOptionList(["12375"]).then((res: objAny) => {
      this.staStatusList = res["12375"];
    });
    //如果路由有带电话参数，则取出来
    if (this.$route.query.staPkId) {
      this.formInline.staPkId = this.$route.query.staPkId;
    }

    this.getTableList();
  }
  beforeRouteEnter(to: objAny, from: objAny, next: Function) {
    if (from.path.indexOf(to.path) != -1) {
      // 从子页面回来
      const name = to.path;
      next((that: objAny) => {
        const formInline = that["$common"].get(name);
        that.formInline = Object.assign(that.formInline, formInline);
        that.isGoBack = true;
      });
    } else {
      next();
    }
  }
  beforeRouteLeave(to: objAny, from: objAny, next: Function) {
    const name = from.path;
    this["$common"].save(name, this.formInline);
    next();
  }

  destroyed() {
    this["$common"].remove("pile-info-item");
  }
}
